import React from "react";
import { getCityMapTitle } from "service/textRetrieval";
import CityMapBox from "components/CityMap/CityMapBox";
// import Style from "components/CityMap/CityMap.module.css";
const CityMap = ({
  textLiterals,
  data
}) => {
  const [rTitle, setRTitle] = React.useState("");
  React.useEffect(() => setRTitle(getCityMapTitle(textLiterals)), [textLiterals]);
  return (
    
      <CityMapBox
        title={rTitle}
        data={data}
      />
   
  );
};

export default CityMap;
